module.exports = __webpack_public_path__ + "static/media/error-token-expired.dd65b634.png";